<template>
  <div class="container left-right-page" v-if="selectedLocation">
    <header class="blur"></header>
    <main>
      <div class="row">
        <left-location-details :selectedLocation="selectedLocation"
          :locationStatus="locationStatus"></left-location-details>
        <div class="right col-lg-8">
          <div v-if="locationReviews.length">
            <reviews-item v-for="(review, index) in locationReviews" :item="review" :key="index"></reviews-item>
          </div>
          <div v-else>
            <empty-data iconColor="#444" :message="$t('empty.reviews')" icon="k-icon-star" textColor="#000"></empty-data>
          </div>
        </div>
      </div>
    </main>
  </div>
  <div v-else>
    <empty-data iconColor="#444" :message="$t('empty.no_location_selected')" icon="k-icon-forkstar-outline"
      textColor="#000"></empty-data>
  </div>
</template>
<script>
import { FormGroupInput, Button } from "@/components";
import { mapActions, mapState } from "vuex";
import { LeftLocationDetails, EmptyData } from "@/views/components";
import { canMakeOrder } from "@/utilities/helper";

export default {
  name: "reviews",
  bodyClass: "reviews-page",
  computed: {
    ...mapState('userStore', ['userReviews']),
    ...mapState('userStore', ['business','locationReviews']),
    locationStatus: function () {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    }
  },
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    LeftLocationDetails,
    EmptyData
  },
  data() {
    return {
      isMounted: false
    };
  },
  methods: {
    ...mapActions('locationStore', ["fetchLocationReviews"])

  },
  created() {
    if (this.selectedLocation)
      this.fetchLocationReviews(this.selectedLocation.id);

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>
<style scoped>
.container {
  max-width: 1250px;
  margin: -3px auto 30px;
  padding: 0 !important;
  width: 90%;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
}

header {
  background: #eee;
  background-image: url("~/img/header-blur.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 250px;
}

header i {
  position: relative;
  cursor: pointer;
  right: -96%;
  top: 25px;
  font-size: 18px !important;
  color: #fff;
}

@media (max-width: 800px) {
  header {
    height: 150px;
  }

  header i {
    right: -90%;
  }
}

main {
  padding: 20px 20px 0px 20px;
}


.nav-tabs>.nav-item>.nav-link {
  padding: 10px 13px;
}

.nav-tabs {
  border: 0;
  padding: 15px 0 !important;
}
</style>
